import type { FullTranslation } from "../../lib/i18n"

export const CASE_STUDY_DETAIL_T = {
  copyCampaign: { FR: "Copier cette campagne", EN: "Copy this campaign" },
  featuredHeading: {
    FR: "Ce que l'outil trouve sur une entreprise",
    EN: "What the tool finds on one business",
  },
  takeawayLabel: { FR: "À retenir", EN: "The takeaway" },
  ctaHeading: {
    FR: "Lancez la même campagne sur votre cible",
    EN: "Run the same campaign on your own target",
  },
  unitEmails: { FR: "emails", EN: "emails" },
  unitPhones: { FR: "téléphones", EN: "phones" },
  onBusinesses: {
    FR: "sur {n} entreprises qualifiées",
    EN: "across {n} qualified businesses",
  },
  onOneBusiness: {
    FR: "sur 1 entreprise qualifiée",
    EN: "across 1 qualified business",
  },
  inCities: { FR: "dans {n} villes", EN: "in {n} cities" },
  withoutTool: { FR: "Sans AutoLeads", EN: "Without AutoLeads" },
  withTool: { FR: "Avec AutoLeads", EN: "With AutoLeads" },
  withoutToolCost: {
    FR: "{time} de qualification et de rédaction, {euros} € de main d'oeuvre",
    EN: "{time} of qualifying and writing, {euros} EUR of labour",
  },
  withToolCost: {
    FR: "0 min de saisie : contacts qualifiés et séquences déjà écrites",
    EN: "0 min of typing: contacts qualified and sequences already written",
  },
  byHandBasis: {
    FR: "estimation à {minutes} min par lead, à 30 €/h",
    EN: "estimated at {minutes} min per lead, at 30 EUR/h",
  },
  keywordsMore: { FR: "Aussi ciblé :", EN: "Also targeted:" },
  salesViewEyebrow: {
    FR: "Livré avec chaque lead",
    EN: "Delivered with every lead",
  },
  salesViewHeading: {
    FR: "De la fiche client à la prospection automatisée",
    EN: "From prospect sheet to automated outreach",
  },
  salesViewStepLabel: { FR: "Étape {n}", EN: "Step {n}" },
  salesViewFiche: { FR: "Fiche client", EN: "Prospect sheet" },
  salesViewFicheBody: {
    FR: "Ce que l'audit et l'enrichissement ont trouvé de concret.",
    EN: "What the audit and enrichment found, in concrete terms.",
  },
  salesViewDrafts: {
    FR: "Mail et script d'appel",
    EN: "Email and call script",
  },
  salesViewDraftsBody: {
    FR: "Rédigés à partir de ces failles : chaque passage surligné reprend un point de la fiche.",
    EN: "Written from those gaps: each highlighted passage reuses a point from the sheet.",
  },
  salesViewAuto: {
    FR: "Prospection automatisée",
    EN: "Automated outreach",
  },
  salesViewAutoBody: {
    FR: "Mail, LinkedIn et appel s'enchaînent seuls, jour après jour.",
    EN: "Mail, LinkedIn and calls run on their own, day after day.",
  },
  salesViewSummary: {
    FR: "{c} contacts · {a} points d'audit",
    EN: "{c} contacts · {a} audit findings",
  },
  salesViewFactsSearch: {
    FR: "Recherches où il est absent",
    EN: "Searches it is missing from",
  },
  salesViewFactsBroken: { FR: "Failles du site", EN: "Site gaps" },
  salesViewFactsGeo: { FR: "Visibilité IA", EN: "AI visibility" },
  salesViewFactsSignal: { FR: "Signaux forts", EN: "Strong signals" },
  salesViewPerMonth: { FR: "{n}/mois", EN: "{n}/mo" },
  salesViewAbsent: { FR: "absent", EN: "absent" },
  salesViewPosition: { FR: "n° {n}", EN: "#{n}" },
  salesViewSignalAds: { FR: "Publicité en cours", EN: "Running ads" },
  salesViewSignalHiring: { FR: "Recrute", EN: "Hiring" },
  salesViewMailExample: { FR: "Mail", EN: "Email" },
  salesViewCallExample: { FR: "Appel", EN: "Call" },
  salesViewMailsCount: {
    FR: "{n} mails dans la séquence",
    EN: "{n} emails in the sequence",
  },
  salesViewMailsContacts: {
    FR: "{n} mails × {c} contacts",
    EN: "{n} emails × {c} contacts",
  },
  salesViewScriptCount: {
    FR: "{n} points dans le script",
    EN: "{n} points in the script",
  },
  salesViewTouches: { FR: "touches", EN: "touches" },
  salesViewChannels: { FR: "canaux", EN: "channels" },
  salesViewDays: { FR: "jours", EN: "days" },
  salesViewAutoBadge: {
    FR: "Envoyé et relancé automatiquement",
    EN: "Sent and followed up automatically",
  },
  salesViewDay: { FR: "J+{n}", EN: "D+{n}" },
  salesViewChannelMail: { FR: "Mail", EN: "Mail" },
  salesViewChannelLinkedin: { FR: "LinkedIn", EN: "LinkedIn" },
  salesViewChannelCall: { FR: "Appel", EN: "Call" },
  ctaSubhead: {
    FR: "Campagnes de démonstration en accès libre, sans CB.",
    EN: "Demo campaigns to explore, no card required.",
  },
  ctaBook: {
    FR: "Réserver un appel",
    EN: "Book a call",
  },
  headingFallbackKeyword: { FR: "Leads B2B", EN: "B2B leads" },
  headingIn: { FR: "à", EN: "in" },
  notFoundTitle: { FR: "Cas client introuvable", EN: "Case study not found" },
  contextHeading: { FR: "À propos de ce marché", EN: "About this market" },
  faqHeading: { FR: "Questions fréquentes", EN: "Frequently asked questions" },
  relatedHeading: {
    FR: "Cas clients similaires",
    EN: "Related case studies",
  },
} satisfies FullTranslation

export const CASE_STUDY_META_DESCRIPTION_T = {
  FR: (keyword: string, place: string) =>
    `Comment prospecter les « ${keyword} » à ${place} : structure du marché, où se trouvent les contacts, ce qui fonctionne. Campagne réelle, client anonymisé.`,
  EN: (keyword: string, place: string) =>
    `How to prospect "${keyword}" businesses in ${place}: how the market is structured, where the contacts sit, what lands. Real campaign, client anonymised.`,
}
